<template>
  <TournamentAgeCategoryForm />
</template>
  
<script>
  import TournamentAgeCategoryForm from '@/components/tournament-age-category/AgeCategoryForm.vue';
  export default {
    name: "TournamentAgeCategoryCreatePage",
    components: {
      TournamentAgeCategoryForm,
    },
  };
</script>
  